import { ArrowBack } from '@mui/icons-material'
import { Box, Button, InputAdornment, Menu, MenuItem, Pagination, PaginationItem, Tab, Tabs, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg'
import { useEffect, useMemo, useRef, useState } from 'react';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import downloadbtn from 'packages/novous_web/src/assets/icons/download.svg'
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import { MaterialReactTable, MRT_ColumnDef, MRT_TableOptions, useMaterialReactTable } from 'material-react-table';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import plusIcon from 'packages/novous_web/src/assets/icons/PlusWhiteStroke.svg';
import BulkUploadModal from 'packages/novous_web/src/common/components/BulkUpload';
import dayjs from 'dayjs';
import ModifySubscription from './components/client-subscription-components/ModifySubscription';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import arrow from "packages/novous_web/src/assets/icons/Arrow.svg";
import calendar from "packages/novous_web/src/assets/icons/calendar.svg";
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg'
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import SubscriptionFilterModal from './components/SubscriptionFilterModal';
import NotAuthorized from '../../NotAuthorized';

interface ManageSubscription {
    createdAt: string;
    createdBy: string;
    deviceIds: string[];
    deviceType: string;
    durations: number;
    price: number;
    priceDue: number;
    productItem: string;
    quantity: number;
    startDate: string;
    status: string;
    subscriptionCode: string;
    subscriptionSortKey: string;
    totalPrice: number;
    userName: string
    validTill: string;
    totalOutstandingAmount: number,
    paidAmount: number
}
const data: ManageSubscription[] = []

type ColumnObjType = {
    [key: string | number]: {
        name: string;
        status: boolean;
    };
};

const InternalSubscriptionTable = () => {
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"error" | "success" | "warning" | "info">("error");
    const [isSendingEmail, setIsSendingEmail] = useState(false);

    const navigate = useNavigate();
    const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
    const isSmallScreen = useMediaQuery("(max-width:850px)");
    const [allData, setAllData] = useState<ManageSubscription[]>([]);
    const [filteredData, setFilteredData] = useState<ManageSubscription[]>([]);
    const [paginationKeys, setPaginationKeys] = useState<{ [key: number]: string | null }>({ 1: null });
    const [currentPage, setCurrentPage] = useState(1);
    const { user } = useAuth();
    const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
    const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);
    const [selectedSubscription, setSelectedSubscription] = useState<ManageSubscription | null>(null);
    const [statusTab, setStatusTab] = useState('All');
    const dateRangeArr = [
        "Today",
        "Yesterday",
        "7 Days",
        "15 Days",
        "30 Days",
        "Custom Range",
    ];
    const [selectedDuration, setSelectedDuration] = useState(dateRangeArr[0]);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(
        null
    );
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [filterData, setFilterData] = useState<{ data: any, isfiltered: boolean }>({ data: {}, isfiltered: false });

    const handleUploadModalClose = () => setIsUploadModelOpen(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [matchStatus, setMatchStatus] = useState<null | 'found' | 'not-found'>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [isSubscriptionFilterOpen, setIsSubscriptionFilterOpen] = useState(false);
    const [subscriptionFilterData, setSubscriptionFilterData] = useState<{
        // userName?: string | null;
        status?: string | null;
        productItem?: string | null;
    }>({});

    const {
        data: ClientSubscriptionData,
        error: ClientSubscriptionError,
        errorStatus: ClientSubscriptionErrorStatus,
        loading: ClientSubscriptionLoading,
        fetchData: ClientSubscriptionRequestData,
    } = useApiError<any>(API_ENDPOINTS.clientSubscription.FETCH_SUBSCRIPTION, "POST"
    );

    const isForbidden = ClientSubscriptionErrorStatus === '403';

    const {
        data: clientSubscriptionDownload,
        error: clientSubscriptionDownloadError,
        loading: clientSubscriptionDownloadLoading,
        fetchData: clientSubscriptionDownloadRequestData,
    } = useApiError<any>(API_ENDPOINTS.clientSubscription.DOWNLOAD_SUBSCRIPTION, "POST", 'blob'
    );

    const refreshSubscriptionData = async () => {
        setCurrentPage(1);
        setPaginationKeys({ 1: null });

        await ClientSubscriptionRequestData({
            startDate: startDate || startDateC,
            endDate: endDate || endDateC,
            fleetAdminId: user.id,
            lastEvaluatedKey: null,
            status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
            ...subscriptionFilterData,
        });
    };

    const getDateRange = (range: string) => {
        const today = dayjs();
        let startDate, endDate;

        switch (range) {
            case "Today":
                startDate = today.format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "Yesterday":
                startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
                endDate = startDate;
                break;
            case "7 Days":
                startDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "15 Days":
                startDate = dayjs().subtract(14, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "30 Days":
                startDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            default:
                startDate = "";
                endDate = "";
        }
        return { startDate, endDate };
    };

    let { startDate: startDateC, endDate: endDateC } =
        getDateRange(selectedDuration);

    useEffect(() => {
        if (startDateC !== "" && endDateC !== "") {
        }
    }, [startDateC, endDateC]);

    if (startDate !== "" && endDate !== "") {
        startDateC = startDate;
        endDateC = endDate;
    } else if (startDate === "" && endDate === "") {
        ({ startDate: startDateC, endDate: endDateC } =
            getDateRange(selectedDuration));
    }
    useEffect(() => {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }, [selectedDuration]);

    const handleCalendarClose = () => {
        setShowDatePicker(false);
        setCalendarAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setCalendarAnchorEl(event.currentTarget);
    };

    const handleClose = (value?: string) => {
        console.log("Selected Value:", value);

        if (value) {
            if (selectedDuration === "Custom Range" && value !== "Custom Range") {
                const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
                setStartDate(newStartDate);
                setEndDate(newEndDate);
            }

            setSelectedDuration(value);
            setShowDatePicker(value === "Custom Range");

            if (value === "Custom Range") {
                setCalendarAnchorEl(anchorEl);
            }
        }

        setAnchorEl(null);
    };

    const handleSubscriptionFilterSave = async (filterData: any) => {
        setSubscriptionFilterData(filterData);
        setFilterData({
            data: filterData,
            isfiltered: Object.values(filterData).some(value => value !== null && value !== '')
        });

        setCurrentPage(1);
        setPaginationKeys({ 1: null });

        const response = await ClientSubscriptionRequestData({
            startDate: startDate || startDateC,
            endDate: endDate || endDateC,
            fleetAdminId: user.id,
            lastEvaluatedKey: null,
            status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
            ...filterData,
        });

        if (response?.status === 200) {
            setAlertMessage(response.message);
            setAlertType("success");
            setAlertOpen(true);
        } else {
            setAlertMessage(response?.error);
            setAlertType("error");
            setAlertOpen(true);
        }
    };

    useEffect(() => {
        let dataToFilter = allData;

        // First apply status filter
        if (statusTab !== 'All') {
            dataToFilter = dataToFilter.filter((item) =>
                item.status?.toLowerCase() === statusTab.toLowerCase()
            );
        }

        // Then apply search filter
        if (debouncedSearchQuery.trim() !== '') {
            const searchTerm = debouncedSearchQuery.toLowerCase();

            const searchedData = dataToFilter.filter(item =>
                item.userName?.toLowerCase().includes(searchTerm) ||
                item.productItem?.toLowerCase().includes(searchTerm) ||
                item.status?.toLowerCase().includes(searchTerm) ||
                item.subscriptionCode?.toLowerCase().includes(searchTerm)
            );

            setFilteredData(searchedData);
            setMatchStatus(searchedData.length > 0 ? 'found' : 'not-found');
        } else {
            setFilteredData(dataToFilter);
            setMatchStatus(null);
        }
    }, [debouncedSearchQuery, allData, statusTab]);

    interface ManageSubscriptionResponse {
        records: ManageSubscription[];
        lastEvaluatedKey: string | null;
    }

    useEffect(() => {
        if (clientSubscriptionDownload) {
            try {
                if (clientSubscriptionDownload instanceof Blob) {
                    const url = window.URL.createObjectURL(clientSubscriptionDownload);
                    const a = document.createElement('a');
                    a.href = url;
                    let extension = selectedFormat.toLowerCase();
                    if (extension === 'excel') {
                        extension = 'xlsx';
                    }

                    const fileName = `internal_subscription.${extension}`;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                } else {
                    console.error('Invalid response format. Expected a Blob.');
                }
            } catch (error) {
                console.error('Error downloading file:', error);
            } finally {
                setIsDownloadModalOpen(false);
            }
        }
    }, [clientSubscriptionDownload])

    const handelCustomize = () => {
        setIsCustomizeOpen(!isCustomizeOpen);
    };
    const handleClosed = () => setIsCustomizeOpen(false);
    const handleReset = () => {
        console.log('Reset clicked!');
    };
    const handleDownload = async () => {
        setIsSendingEmail(true);
        const requestData = {
            fleetId: user?.id,
            fileType: selectedFormat,
            startDate: startDate,
            endDate: endDate,
            status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
            ...subscriptionFilterData,
        };

        try {
            const response = await clientSubscriptionDownloadRequestData(requestData);
            if (response?.type === 'text/csv' || response?.type === 'application/pdf' || response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setAlertMessage(`File has been downloaded successfully`);
                setAlertType("success");
                setAlertOpen(true);
            } else {
                setAlertMessage(response?.error);
                setAlertType("error");
                setAlertOpen(true);
            }
        } catch (error) {
            console.error("Error sending email:", error);
            setAlertMessage((error as Error).message);
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setIsSendingEmail(false);
        }
    };

    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFormat(event.target.value);
    };

    const handleDownloadModalClose = () => {
        if (clientSubscriptionDownloadLoading) {
            return;
        }
        setIsDownloadModalOpen(false);
    };

    const [columnObj, setColumnObj] = useState<ColumnObjType>({
        subscriptionCode: { name: "Subscription Code", status: true },
        status: { name: "Status", status: true },
        userName: { name: "Customer Name", status: true },
        productItem: { name: "Product Category", status: true },
        startDate: { name: "Start Date", status: true },
        validTill: { name: "Valid Till", status: true },
        deviceIds: { name: "DeviceId Name", status: true },
        durations: { name: "Durations", status: true },
        quantity: { name: "Total Quantity", status: true },
        totalPrice: { name: "Total Amount", status: true },
        totalOutstandingAmount: { name: "Total Due Amount", status: true },
        paidAmount: { name: "Total Paid Amount", status: true },
        actions: { name: 'Actions', status: true },
    });

    useEffect(() => {
        if (!ClientSubscriptionData?.data?.records) return;

        const records = (ClientSubscriptionData?.data as ManageSubscriptionResponse)?.records ?? [];
        setAllData(records);
    }, [ClientSubscriptionData]);

    useEffect(() => {
        if (ClientSubscriptionData?.data?.lastEvaluatedKey) {
            const nextPage = currentPage + 1;
            const lastEvaluatedKeyStr = JSON.stringify(ClientSubscriptionData?.data?.lastEvaluatedKey);
            if (paginationKeys[nextPage] !== lastEvaluatedKeyStr) {
                setPaginationKeys(prev => ({
                    ...prev,
                    [nextPage]: lastEvaluatedKeyStr
                }));
            }
        }
    }, [ClientSubscriptionData, currentPage]);
    const totalPages = ClientSubscriptionData?.data?.lastEvaluatedKey
        ? Object.keys(paginationKeys).length
        : currentPage;

    const handlePageChange = async (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        if (page === currentPage || ClientSubscriptionLoading) return;
        setCurrentPage(page);
        const keyForTargetPage = paginationKeys[page];

        const requestData: any = {
            startDate: startDate || startDateC,
            endDate: endDate || endDateC,
            fleetAdminId: user.id,
            lastEvaluatedKey: keyForTargetPage ? JSON.parse(keyForTargetPage) : null,
            status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
            ...subscriptionFilterData,
        };
        await ClientSubscriptionRequestData(requestData);
    };

    useEffect(() => {
        const fetchDataWithStatus = async () => {
            if (startDate && endDate) {
                setCurrentPage(1);
                setPaginationKeys({ 1: null });

                try {
                    await ClientSubscriptionRequestData({
                        startDate: startDate || startDateC,
                        endDate: endDate || endDateC,
                        fleetAdminId: user.id,
                        lastEvaluatedKey: null,
                        status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
                        ...subscriptionFilterData,
                    });
                } catch (error) {
                    console.error("Failed to fetch subscription data:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchDataWithStatus();
    }, [statusTab]);

    useEffect(() => {
        const fetchData = async () => {
            if (startDate && endDate) {
                setCurrentPage(1);
                setPaginationKeys({ 1: null });

                try {
                    await ClientSubscriptionRequestData({
                        startDate,
                        endDate,
                        fleetAdminId: user.id,
                        lastEvaluatedKey: null,
                        status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
                        ...subscriptionFilterData,
                    });
                } catch (error) {
                    console.error("Failed to fetch report data:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchData();
    }, [startDate, endDate, filterData]);

    const handleModifyModalClose = () => {
        setIsModifyModalOpen(false);
        setSelectedSubscription(null);
    }

    const formatDuration = (totalSeconds: number): string => {
        const secondsInMinute = 60;
        const secondsInHour = 60 * secondsInMinute;
        const secondsInDay = 24 * secondsInHour;
        const secondsInMonth = 30 * secondsInDay;
        const secondsInYear = 12 * secondsInMonth;

        const years = Math.floor(totalSeconds / secondsInYear);
        totalSeconds %= secondsInYear;

        const months = Math.floor(totalSeconds / secondsInMonth);
        totalSeconds %= secondsInMonth;

        const days = Math.floor(totalSeconds / secondsInDay);
        totalSeconds %= secondsInDay;

        const hours = Math.floor(totalSeconds / secondsInHour);
        totalSeconds %= secondsInHour;

        const minutes = Math.floor(totalSeconds / secondsInMinute);
        const seconds = totalSeconds % secondsInMinute;

        const parts = [];
        if (years) parts.push(`${years} Years`);
        if (months) parts.push(`${months} Months`);
        if (days) parts.push(`${days} Days`);
        if (hours) parts.push(`${hours} Hours`);
        if (minutes) parts.push(`${minutes} Min`);
        if (seconds) parts.push(`${seconds} Sec`);

        return parts.join(' ');
    };

    useEffect(() => {
        if (statusTab === 'All') {
            setFilteredData(allData);
        } else {
            const statusFilteredData = allData.filter((item) =>
                item.status?.toLowerCase() === statusTab.toLowerCase()
            );
            setFilteredData(statusFilteredData);
        }
    }, [statusTab, allData]);

    console.log(filterData, 'filterData');

    const allColumns: MRT_ColumnDef<ManageSubscription>[] = useMemo(
        () => [
            {
                accessorKey: 'subscriptionCode',
                header: 'Subscription Code',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value ? value : 'NA'}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'status',
                header: 'Status',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>()?.toLowerCase() || 'na';

                    const statusStyles: Record<string, { bg: string; color: string }> = {
                        active: { bg: '#D9EDE6', color: '#219653' },
                        'expiring_soon': { bg: '#FFF4E5', color: '#F2994A' },
                        expired: { bg: '#FDEDED', color: '#EB5757' },
                        terminated: { bg: '#E0E0E0', color: '#4F4F4F' },
                        na: { bg: '#F2F2F2', color: '#828282' },
                    };

                    const { bg, color } = statusStyles[value] || statusStyles['na'];

                    return (
                        <Typography
                            variant="body2"
                            fontWeight={400}
                            noWrap
                            sx={{
                                textTransform: 'capitalize',
                                width: 'fit-content',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '8px',
                                padding: '4px 8px',
                                backgroundColor: bg,
                                color: color,
                            }}
                        >
                            {value}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'userName',
                header: 'Customer Name',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value ? value : 'NA'}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'productItem',
                header: 'Product Category',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value ? value : 'NA'}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'startDate',
                header: 'Start Date',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    const formattedDate = value ? dayjs(value).format('D MMMM YYYY') : 'NA';

                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {formattedDate}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'durations',
                header: 'Duration',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<number>();
                    const formattedDuration = formatDuration(value);
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {formattedDuration || 'NA'}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'quantity',
                header: 'Total Quantity',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<number>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value ? value : 0}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'totalPrice',
                header: 'Total Amount',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<number>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value ? value : 0}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'totalOutstandingAmount',
                header: 'Total Due Amount',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell, row }) => {
                    const value = cell.getValue<number>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value !== undefined && value !== null ? value : row.original.totalPrice}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'paidAmount',
                header: 'Total Paid Amount',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell, row }) => {
                    const value = cell.getValue<number>();
                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {value}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'deviceIds',
                header: 'DeviceId Name',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string[]>();

                    if (!value || value.length === 0) {
                        return (
                            <Typography variant="body2" fontWeight={400} noWrap>
                                NA
                            </Typography>
                        );
                    }

                    const firstTwo = value.slice(0, 2).join(', ');
                    const remainingCount = value.length - 2;
                    const allVehicles = value.join(', ');

                    return (
                        <Tooltip title={allVehicles}>
                            <Typography variant="body2" fontWeight={400} noWrap sx={{ cursor: 'pointer' }}>
                                {firstTwo}
                                {remainingCount > 0 && ` +${remainingCount} More`}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                accessorKey: 'validTill',
                header: 'Valid Till',
                enableColumnActions: false,
                size: isSmallScreen ? 100 : 150,
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    const formattedDate = value ? dayjs(value).format('D MMMM YYYY') : 'NA';

                    return (
                        <Typography variant="body2" fontWeight={400} noWrap>
                            {formattedDate}
                        </Typography>
                    );
                },
            },
            {
                accessorKey: 'actions',
                header: 'Actions',
                muiTableBodyCellProps: { sx: { padding: '8px' } },
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 180,
                Cell: ({ row }) => {
                    const validTillDate = dayjs(row.original.validTill);
                    const currentDate = dayjs();
                    const isRenewable = currentDate.isAfter(validTillDate);

                    return (
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                            <CustomIconButton
                                text="Modify"
                                variant='contained'
                                background="transparent"
                                outline={false}
                                onClick={() => {
                                    setIsModifyModalOpen(true);
                                    setSelectedSubscription(row.original);
                                }}
                                isDisabled={row.original.status === 'terminated'}
                            />
                            <CustomIconButton
                                text="Renew Subscription"
                                variant='contained'
                                background="transparent"
                                outline={false}
                                onClick={() => navigate("renew-subscription", { state: row.original })}
                                isDisabled={!isRenewable || row.original.status === 'terminated'}
                            />
                        </Box>
                    );
                },
            },
        ],
        [isSmallScreen]
    );

    const columns: MRT_ColumnDef<ManageSubscription>[] = useMemo(() => {
        return allColumns.filter((column) => {
            const key = column.accessorKey as keyof ColumnObjType;
            return columnObj[key]?.status;
        });
    }, [allColumns, columnObj]);

    const tableOptions: MRT_TableOptions<ManageSubscription> = {
        columns,
        data: filteredData,
        enablePagination: false,
        enableColumnFilters: false,
        enableSorting: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableHiding: false,
        enableBottomToolbar: false,
        enableTopToolbar: false,
        enableFullScreenToggle: false,
        enableToolbarInternalActions: false,
        enableColumnPinning: true,
        initialState: {
            columnPinning: {
                left: ['subscriptionCode'],
                right: ['actions'],
            },
        },
        muiTableBodyProps: {
            sx: {
                padding: 0,
                margin: 0,
            },
        },
        muiTableProps: {
            sx: {
                overflow: 'scroll',
            },
        },
    };

    const table = useMaterialReactTable(tableOptions);

    const handleClearFilters = async () => {
        setSubscriptionFilterData({});
        setFilterData({ data: {}, isfiltered: false });
        setSearchQuery('');

        // Refresh data without any filters
        setCurrentPage(1);
        setPaginationKeys({ 1: null });

        await ClientSubscriptionRequestData({
            startDate: startDate || startDateC,
            endDate: endDate || endDateC,
            fleetAdminId: user.id,
            lastEvaluatedKey: null,
            status: statusTab === 'All' ? undefined : statusTab.toLowerCase(),
            // No additional filters - this will get all data
        });
    };

    return (
        <div>
            <AlertToast message={alertMessage} type={alertType} open={alertOpen} onClose={() => setAlertOpen(false)} />
            {isLoading ? (
                <></>
            ) : isForbidden ? (
                <NotAuthorized />
            ) : (
                <>
                    <div className="w-full mb-4">
                        <CustomIconButton
                            icon={<ArrowBack />}
                            text="Back"
                            background="transparent"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                    <div className=' w-full flex lg:flex-row md:flex-row flex-col justify-between gap-4 xs:flex-col items-start mb-4'>
                        <div className="w-[25%]">
                            <div className="dashboard-header-left">
                                <div className="flex flex-col items-start">
                                    <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                                        Manage Subscriptions
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <div className="flex gap-4 flex-wrap">
                            <CustomIconButton
                                icon={<img src={Custom} alt="Custom" width={16} height={16} />}
                                text="Customize"
                                background='transparent'
                                outline={false}
                                onClick={handelCustomize}
                            />
                            <CustomiseTableModal
                                open={isCustomizeOpen}
                                onClose={handleClosed}
                                onReset={handleReset}
                                title="Customize Your Table"
                                description="Select and arrange table columns as you prefer."
                                columnObj={columnObj}
                                setColumnObj={setColumnObj}
                            />
                            {/* <CustomIconButton
                        icon={<img src={bulkUpload} alt="Bulk Upload" width={24} height={24} />}
                        text="Bulk Upload"
                        variant='contained'
                        background="transparent"
                        onClick={() => setIsUploadModelOpen(true)}
                    /> */}
                            {selectedDuration === "Custom Range" && (
                                <div className="flex items-center">
                                    <Box
                                        sx={(theme) => ({
                                            backgroundColor: theme.palette.selected,
                                            borderRadius: "8px",
                                            padding: theme.spacing(1),
                                        })}
                                    >
                                        <Typography
                                            variant="subtitle2"
                                            className="truncate"
                                            sx={{ fontWeight: 700, marginRight: 1 }}
                                        >
                                            <span style={{ color: "#235AF9" }}>
                                                {startDateC} - {endDateC}
                                            </span>
                                        </Typography>
                                    </Box>
                                </div>
                            )}

                            <div className="relative">
                                <Button
                                    onClick={handleClick}
                                    variant="outlined"
                                    sx={{
                                        height: { xs: "28px", sm: "30px", md: "48px" },
                                        px: { xs: 1, sm: 2 },
                                        borderRadius: "8px",
                                        textTransform: "none",
                                        fontWeight: 700,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: { xs: 0.5, sm: 1 },
                                        borderColor: "#5547dd",
                                        backgroundColor: "white",
                                        color: "#5547dd",
                                        minWidth: 0,
                                        maxWidth: "100%",
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <img src={calendar} alt="Calendar" width={18} height={18} />
                                        <Box sx={{ display: "block", maxWidth: "100%" }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {selectedDuration}
                                            </Typography>
                                        </Box>
                                        <img src={arrow} alt="Arrow" width={18} height={18} />
                                    </Box>
                                </Button>

                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={() => handleClose()}
                                    PaperProps={{
                                        sx: {
                                            borderRadius: "8px",
                                            top: "10px",
                                            boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                                        },
                                    }}
                                >
                                    {dateRangeArr.map((label) => (
                                        <MenuItem
                                            key={label}
                                            onClick={() => handleClose(label)}
                                            sx={(theme) => ({
                                                transition: "all 0.2s ease-in-out",
                                                "&:hover": {
                                                    backgroundColor: theme.palette.action.hover,
                                                },
                                                backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                                            })}
                                        >
                                            <Typography variant="button" textTransform={"none"}>
                                                {label}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </Menu>
                                <Menu
                                    anchorEl={calendarAnchorEl}
                                    open={showDatePicker}
                                    onClose={handleCalendarClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                borderRadius: "8px",
                                                top: "10px",
                                                padding: "0px",
                                                boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                                            },
                                        },
                                    }}
                                >
                                    <DateRangeFilter
                                        onCancel={handleCalendarClose}
                                        onApply={(from, to) => {
                                            setStartDate(from);
                                            setEndDate(to);
                                            setSelectedDuration("Custom Range");
                                            setShowDatePicker(false);
                                            setCalendarAnchorEl(null);
                                        }}
                                        initialFrom={startDate}
                                        initialTo={endDate}
                                    />
                                </Menu>
                            </div>
                            <CustomIconButton
                                icon={<img src={downloadbtn} alt="download" width={16} height={16} />}
                                text="Download"
                                variant='contained'
                                background='transparent'
                                onClick={() => setIsDownloadModalOpen(!isDownloadModalOpen)}
                            />
                            <CustomIconButton
                                icon={<img src={plusIcon} alt="download" width={16} height={16} />}
                                text="New Subscription"
                                variant='contained'
                                onClick={() => navigate("create")}
                            />
                            <DownloadData
                                downloadLoading={clientSubscriptionDownloadLoading}
                                isDownloadModalOpen={isDownloadModalOpen}
                                handleDownloadModalClose={handleDownloadModalClose}
                                selectedFormat={selectedFormat}
                                handleFormatChange={handleFormatChange}
                                handleDownload={handleDownload}
                                modalTitle="Download All Subscriptions"
                                modalDescription="Please select a file format for your download."
                                formatLabel="Format"
                                formatExcelLabel="Excel"
                                formatCsvLabel="CSV"
                                formatPdfLabel="PDF"
                                cancelButtonText="Cancel"
                                downloadButtonText="Download"
                            />
                            {isUploadModelOpen && (
                                <BulkUploadModal
                                    open={isUploadModelOpen}
                                    handleClose={handleUploadModalClose}
                                    uploadEndpoint={API_ENDPOINTS.clientSubscription.BULK_UPLOAD}
                                    title="Bulk Upload"
                                    description="Upload an Excel/CSV files to add multiple subscriptions at once!"
                                    entityType="subscriptions"
                                    sampleFileUrl={API_ENDPOINTS.clientSubscription.SAMPLE_FILE_BULK_DOWNLOAD}
                                />
                            )}
                        </div>
                    </div>
                    <Box className='w-full my-4 bg-[#EEEDFC] flex lg:flex-row md:flex-row flex-col items-center justify-between' gap={2} borderRadius="8px">
                        <Tabs
                            value={statusTab}
                            onChange={(e, newValue) => setStatusTab(newValue)}
                            sx={{
                                borderRadius: "8px",
                                padding: 2,
                            }}
                            TabIndicatorProps={{ style: { display: "none" } }}
                        >
                            {["All", "Active", "Expired", "Expiring_Soon", "Terminated"].map((label) => (
                                <Tab
                                    key={label}
                                    value={label}
                                    label={label}
                                    sx={{
                                        ...(statusTab === label
                                            ? {
                                                backgroundColor: "#fff",
                                                color: "#1976d2",
                                                fontWeight: 600,
                                                borderRadius: "8px",
                                                padding: "8px 16px",
                                                boxShadow: "0px 4px 6px #00000014",
                                            }
                                            : {
                                                color: "#333",
                                            }),
                                    }}
                                />
                            ))}
                        </Tabs>
                        <div className="flex gap-2">
                            <div className="max-w-[400px]">
                                <TextField
                                    variant="outlined"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search"
                                    sx={{
                                        width: '400px',
                                        height: '48px',
                                        paddingRight: '16px',
                                        paddingLeft: '16px',
                                        gap: '12px',
                                        borderRadius: '8px',
                                        borderWidth: '1px',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            height: '48px',
                                        },
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={searchIcon} alt="search" width={16} height={16} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                sx={{
                                                    cursor: 'pointer',
                                                    borderLeft: '1px solid #e0e0e0',
                                                    paddingLeft: '8px',
                                                }}
                                            >
                                                <img
                                                    src={filterIcon}
                                                    onClick={() => setIsSubscriptionFilterOpen(true)}
                                                    alt="filter"
                                                    width={24}
                                                    height={24}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            {filterData.isfiltered && (
                                <CustomIconButton
                                    text={`Clear Filters (${Object.values(subscriptionFilterData).filter((value) => value !== null && value !== '').length})`}
                                    background="transparent"
                                    outline={false}
                                    textColor="#C83333"
                                    onClick={handleClearFilters}
                                />
                            )}
                        </div>
                    </Box>

                    <SubscriptionFilterModal
                        open={isSubscriptionFilterOpen}
                        onClose={() => setIsSubscriptionFilterOpen(false)}
                        handleFilterSave={handleSubscriptionFilterSave}
                        subscriptionData={allData}
                        initialFilters={subscriptionFilterData}
                    />

                    <MaterialReactTable
                        table={table}
                    />
                    {isModifyModalOpen && (
                        <ModifySubscription
                            open={isModifyModalOpen}
                            onClose={handleModifyModalClose}
                            subscription={selectedSubscription}
                            onSubscriptionUpdated={refreshSubscriptionData}
                        />
                    )}
                    <Box display="flex" justifyContent="center" mt={2}>
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            shape="rounded"
                            color="primary"
                            siblingCount={0}
                            boundaryCount={0}
                            renderItem={(item) => {
                                if (
                                    item.type === "page" &&
                                    item.page !== null &&
                                    item.page > currentPage
                                ) {
                                    return null;
                                }
                                return <PaginationItem {...item} />;
                            }}
                        />
                    </Box>
                </>
            )}
        </div>
    )
}

export default InternalSubscriptionTable